export const CONTENT_ADDED_AT = 'Ajouté le';
export const EMPTY_TITLE = 'Sans titre';
export const END_EDITION_TEXT = "Terminer l'édition";
